import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import classNames from "classnames"
import { useConfirmationModalContext } from "features/modals/WorkspaceConfirmationModalV2"
import QRCode from "react-qr-code"

export const ExpandableQRCode = ({
    title,
    onClick,
    value,
    size,
    className,
    fgColor,
    bgColor,
}: {
    title: string
    value: string
    onClick?: React.MouseEventHandler<SVGSVGElement>
    size?: number
    className?: string
    fgColor?: string
    bgColor?: string
}) => {
    const confirmationModal = useConfirmationModalContext()
    return (
        <QRCode
            size={size}
            value={value}
            fgColor={fgColor}
            bgColor={bgColor}
            className={classNames("cursor-zoom-in", className)}
            onClick={(e) => {
                onClick?.(e)
                confirmationModal.confirm({
                    RenderComponent: ({ cancel }) => {
                        return (
                            <HighPriorityNovaModalContainer title={title} closeModal={cancel}>
                                <div className="flex justify-center items-center">
                                    <QRCode size={250} value={value} />
                                </div>
                            </HighPriorityNovaModalContainer>
                        )
                    },
                })
            }}
        />
    )
}
